import {Rule} from 'antd/lib/form';

export const idRules: Rule[] = [
    {required: true, message: '请选择弹性公网IP实例'},
];
